export const triggerTypes = {
	passive: 'passive',
	proactive: 'proactive',
	exit: 'exit',
};

export const showAlwaysPerSessionTriggers = [triggerTypes.passive];

export const showOncePerSessionTriggers = [triggerTypes.proactive, triggerTypes.exit];
